import BaseComponent from './BaseComponent';

abstract class StatelessBaseComponent<P> extends BaseComponent<P, EmptyState> {

	constructor(props: P) {
		super(props);
	}

	createInitialState(_props: P): Nullable<EmptyState> {
		return null;
	}
}

export default StatelessBaseComponent;
